"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsmMarker = exports.withPublicRuntimeConfig = exports.withServerRuntimeConfig = exports.SHORT_REGION = exports.ASSET_PREFIX = exports.CX_IDENTIFIER_TEMPLATE = exports.IS_ONE_BOX = exports.IS_STAGE_PROD = exports.IS_LOCAL_DEV = exports.LOGGER_CONTEXT_RID_KEY = exports.SHOPPING_PORTAL_PREFIX = exports.ENV_TENANT_ID = exports.ENV_SERVERCERTS_HTTP_SERVERNAME = exports.ENV_APP_PREFIX = exports.ENV_STAGE = exports.ENV_SHOPPING_PORTAL = exports.ENV_REGION = exports.ENV_RDE_MONERA_SERVICE_URL = exports.ENV_RDE = exports.ENV_PRODUCTION = exports.ENV_PORT_SSL = exports.ENV_PORT = exports.ENV_PAGE = exports.ENV_MOCK = exports.ALL = exports.INTERNAL = exports.ROBOT = exports.OPENID_NS = exports.OPENID_MODE = exports.OPENID_MAX_AUTH_AGE_PARAM = exports.OPENID_ASSOC_HANDLE_PARAM = exports.OPENID_RETURN_TO_PARAM = exports.OPENID_NS_PAPE_PARAM = exports.OPENID_NS_EXTENSION = exports.OPENID_NS_PARAM = exports.OPENID_MODE_PARAM = exports.STATUS_CODE_PARAM = exports.SITE = exports.GRAPHQL_URL = exports.SERVICE_NAME_PREFIX = exports.CLOUDWATCH_RETRY_MAX_ATTEMPTS = void 0;
exports.CLOUDWATCH_RETRY_MAX_ATTEMPTS = 3;
exports.SERVICE_NAME_PREFIX = 'MoneraApp2';
exports.GRAPHQL_URL = '/graphql';
exports.SITE = 'Monera';
exports.STATUS_CODE_PARAM = 'code';
exports.OPENID_MODE_PARAM = 'openid.mode';
exports.OPENID_NS_PARAM = 'openid.ns';
exports.OPENID_NS_EXTENSION = 'http://specs.openid.net/extensions/pape/1.0';
exports.OPENID_NS_PAPE_PARAM = 'openid.ns.pape';
exports.OPENID_RETURN_TO_PARAM = 'openid.return_to';
exports.OPENID_ASSOC_HANDLE_PARAM = 'openid.assoc_handle';
exports.OPENID_MAX_AUTH_AGE_PARAM = 'openid.pape.max_auth_age';
exports.OPENID_MODE = 'checkid_setup';
exports.OPENID_NS = 'http://specs.openid.net/auth/2.0';
exports.ROBOT = 'Robot';
exports.INTERNAL = 'Internal';
exports.ALL = 'ALL';
exports.ENV_MOCK = process.env.MOCK === 'true';
exports.ENV_PAGE = process.env.PAGE || '';
exports.ENV_PORT = parseInt(process.env.PORT || '8080', 10);
exports.ENV_PORT_SSL = parseInt(process.env.PORT_SSL || '9080', 10);
exports.ENV_PRODUCTION = process.env.NODE_ENV === 'production';
exports.ENV_RDE = process.env.IS_RDE === 'true';
exports.ENV_RDE_MONERA_SERVICE_URL = (_a = process.env.RDE_MONERA_SERVICE_URL) !== null && _a !== void 0 ? _a : 'http://127.0.0.1:8080';
exports.ENV_REGION = process.env.REGION || 'us-east-1';
exports.ENV_SHOPPING_PORTAL = process.env.NO_SP ? !process.env.NO_SP : true;
exports.ENV_STAGE = (_b = process.env.STAGE) !== null && _b !== void 0 ? _b : 'local';
exports.ENV_APP_PREFIX = process.env.APP_PREFIX || '';
exports.ENV_SERVERCERTS_HTTP_SERVERNAME = process.env.SERVERCERTS_HTTP_SERVERNAME || '';
exports.ENV_TENANT_ID = process.env.TENANT_ID || '';
exports.SHOPPING_PORTAL_PREFIX = exports.ENV_SHOPPING_PORTAL ? '/adgmonera/webapp2' : '';
exports.LOGGER_CONTEXT_RID_KEY = 'rid';
exports.IS_LOCAL_DEV = exports.ENV_STAGE === 'local';
exports.IS_STAGE_PROD = exports.ENV_STAGE === 'prod';
exports.IS_ONE_BOX = process.env.IS_ONE_BOX || false;
exports.CX_IDENTIFIER_TEMPLATE = process.env.CX_IDENTIFIER_TEMPLATE;
const resolveShortRegion = () => {
    switch (exports.ENV_REGION) {
        case 'us-east-1':
            return 'na';
        case 'eu-west-1':
        case 'eu-south-2':
        case 'eu-central-1':
            return 'eu';
        case 'us-west-2':
            return 'fe';
        default:
            throw new Error(`awsRegion not supported: ${exports.ENV_REGION}`);
    }
};
const resolveAssetPrefix = () => {
    if (exports.ENV_STAGE === 'test' || exports.ENV_STAGE === 'local') {
        return exports.SHOPPING_PORTAL_PREFIX;
    }
    if (exports.ENV_APP_PREFIX !== '' && exports.ENV_SERVERCERTS_HTTP_SERVERNAME !== '') {
        return `https://${exports.ENV_APP_PREFIX.toLowerCase()}-${exports.ENV_SERVERCERTS_HTTP_SERVERNAME}/monera-app`;
    }
    return '';
};
exports.ASSET_PREFIX = resolveAssetPrefix();
exports.SHORT_REGION = resolveShortRegion();
const withServerRuntimeConfig = () => {
    let moneraServiceUrl;
    switch (exports.ENV_STAGE) {
        case 'test':
        case 'local':
            moneraServiceUrl = exports.ENV_RDE ? exports.ENV_RDE_MONERA_SERVICE_URL : 'http://127.0.0.1:8080';
            break;
        case 'beta':
        case 'gamma':
        case 'prod':
            moneraServiceUrl = `https://${exports.ENV_REGION}.${exports.ENV_STAGE}-${exports.SHORT_REGION}-2.service.monera.adg.a2z.com`;
            break;
        default:
            throw new Error('Unhandled stage: ' + exports.ENV_STAGE);
    }
    const moneraServiceGraphQlUrl = `${moneraServiceUrl}${exports.GRAPHQL_URL}`;
    return {
        moneraServiceUrl,
        moneraServiceGraphQlUrl,
        isMock: exports.ENV_MOCK,
        shoppingPortalPrefix: exports.SHOPPING_PORTAL_PREFIX
    };
};
exports.withServerRuntimeConfig = withServerRuntimeConfig;
const withPublicRuntimeConfig = () => {
    let moneraServiceUrl = `/adgmonera/api2`;
    let amazonUrl = '';
    switch (exports.ENV_STAGE) {
        case 'test':
        case 'local':
            moneraServiceUrl = exports.ENV_RDE
                ? exports.ENV_RDE_MONERA_SERVICE_URL
                : exports.ENV_SHOPPING_PORTAL
                    ? exports.SHOPPING_PORTAL_PREFIX
                    : `https://localhost.amazon.com:${exports.ENV_PORT_SSL}`;
            amazonUrl = 'https://development.amazon.com';
            break;
        case 'beta':
            break;
        case 'gamma':
            break;
        case 'prod':
            break;
        default:
            throw new Error('Unhandled stage: ' + exports.ENV_STAGE);
    }
    const moneraServiceGraphQlUrl = `${moneraServiceUrl}${exports.GRAPHQL_URL}`;
    return {
        assetPrefix: exports.ASSET_PREFIX,
        envRegion: exports.ENV_REGION,
        envStage: exports.ENV_STAGE,
        envShoppingPortal: exports.ENV_SHOPPING_PORTAL,
        moneraServiceUrl,
        moneraServiceGraphQlUrl,
        amazonUrl,
        isMock: exports.ENV_MOCK,
        shoppingPortalPrefix: exports.SHOPPING_PORTAL_PREFIX,
        isOneBox: exports.IS_ONE_BOX
    };
};
exports.withPublicRuntimeConfig = withPublicRuntimeConfig;
var CsmMarker;
(function (CsmMarker) {
    CsmMarker["ATF"] = "af";
    CsmMarker["NEW_REQUEST_ID"] = "id";
    CsmMarker["CRITICAL_FEATURE"] = "cf";
    CsmMarker["FUNCTIONAL"] = "fn";
    CsmMarker["TIME_OF_CLICK"] = "tc";
    CsmMarker["MOBILE_TRANSITION_START"] = "mts";
    CsmMarker["USE_CLIENT_SIDE_TIMESTAMPS_FOR_AJAX"] = "ctb";
    CsmMarker["PAGE_LOAD"] = "ld";
    CsmMarker["AJAX_RESPONSE_RECEIVED"] = "t0";
})(CsmMarker = exports.CsmMarker || (exports.CsmMarker = {}));
